import { createMuiTheme } from '@material-ui/core/styles'


const theme = createMuiTheme({
  palette: {
    background: {
      paper: '#D8D8D8',
    },
    primary: {
      main: '#2d98da',
      dark: '#4b7bec',
      light: '#45aaf2',
    },
    secondary: {
      main: '#fd9644',
      dark: '#fa8231',
      light: '#f7b731',
      contrastText: '#FFF',
    },
  },

  spacing: 20,

  props: {
    MuiChip: {
      variant: 'outlined',
    },
  },

  overrides: {
    MuiTableCell: {
      body: {
        borderBottom: 0,
      },
    },
  },
})


export default theme
